var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEbatWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.386,
    height: 20,
    viewBox: "0 0 66.386 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-135.764 -1001.138)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M143.442,1021.453a7.811,7.811,0,1,0,7.23,10.554h-4.486a3.079,3.079,0,0,1-2.665,1.372,3.277,3.277,0,0,1-3.43-2.77h10.976a5.58,5.58,0,0,0,.106-1.161A7.721,7.721,0,0,0,143.442,1021.453Zm-3.3,6.2a3.458,3.458,0,0,1,6.649,0Z",
    transform: "translate(0 -15.935)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M302.938,1001.138l-7.836,19.525h5.356l1.029-2.823h6.781l.95,2.823h5.409l-7.757-19.525Zm-.079,12.744,2.005-6.675.079.026,2.005,6.649Z",
    transform: "translate(-124.984 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M384.932,1001.138v4.38h3.852v15.145h4.987v-15.145H397.6v-4.38Z",
    transform: "translate(-195.447 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M222.4,1068.584a6.081,6.081,0,0,0-3.67-1.721l-.031,0v1.41l.03,0a4.653,4.653,0,0,1,2.669,1.3,4.547,4.547,0,0,1,1.319,2.634s0,0,0,.007h1.427s0-.005,0-.007A5.933,5.933,0,0,0,222.4,1068.584Z",
    transform: "translate(-65.052 -51.551)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M224.636,1054.986a9.251,9.251,0,0,0-5.907-2.644l-.032,0v1.482h.032a7.723,7.723,0,0,1,4.846,2.212,7.537,7.537,0,0,1,2.241,4.783s0,.006,0,.008h1.5v-.009A9.024,9.024,0,0,0,224.636,1054.986Z",
    transform: "translate(-65.052 -40.161)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M220.22,1081.9a2.986,2.986,0,0,0-1.5-.8l-.028-.007v2.286h2.334v0A2.925,2.925,0,0,0,220.22,1081.9Z",
    transform: "translate(-65.052 -62.717)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M230.518,1010.65a4.429,4.429,0,0,0,3.31-4.45c0-3.087-2.364-5.062-6.342-5.062H218.7v9.392h.032a10.976,10.976,0,0,1,3.477.77,10.841,10.841,0,0,1,3.606,2.364,10.651,10.651,0,0,1,3.172,6.936c3.377-.37,5.289-2.349,5.289-5.249A4.735,4.735,0,0,0,230.518,1010.65Zm-3.949-1.613h-3.115v-4.088h3.115c1.558,0,2.42.723,2.42,2.058S228.126,1009.037,226.568,1009.037Z",
    transform: "translate(-65.052 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbatWhite);
export default __webpack_public_path__ + "static/media/ebat-white.d6fe0ce6.svg";
export { ForwardRef as ReactComponent };